import Phaser from 'phaser';

/** Boot: nothing to load yet (assets are generated). Hand off to Preload. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    this.scene.start('Preload');
  }
}
